import api from 'service/api'

const dponetAPI = api.create('dponet')
const dponetTreatAPI = api.create('dponet', false)

const index = async ({ ...params }) => {
  return dponetAPI.get('/training_courses', { params })
}

const show = async ({ courseId }) => {
  return dponetAPI.get(`/training_courses/${courseId}`)
}

const modules = async ({ courseId }) => {
  return dponetAPI.get(`/training_courses/${courseId}/modules`)
}

const certificateConfig = async ({ courseId }) => {
  return dponetAPI.get(`/training_courses/${courseId}/certificate`)
}

const courseCompanyConfig = async ({ courseId }) => {
  return dponetAPI.get(
    `/training_courses/${courseId}/training_course_company_config`,
  )
}

const upsertCourseCompanyConfig = async ({ courseId, ...params }) => {
  return dponetAPI.post(
    `/training_courses/${courseId}/training_course_company_config/upsert`,
    params,
  )
}

const notificationEmails = async ({ courseId }) => {
  return dponetAPI.get(
    `/training_courses/${courseId}/training_course_notification_emails`,
  )
}

const createNotificationEmail = async ({ courseId, email }) => {
  return dponetAPI.post(
    `/training_courses/${courseId}/training_course_notification_emails`,
    { email },
  )
}

const deleteNotificationEmail = async ({ courseId, id }) => {
  return dponetAPI.delete(
    `/training_courses/${courseId}/training_course_notification_emails/${id}`,
  )
}

const categories = async () => {
  return dponetAPI.get('/training_courses/categories')
}

const portalLink = async () => {
  return dponetTreatAPI.get('/training_courses/portal_link')
}

const departments = async () => {
  return dponetAPI.get('/training_courses/departments')
}

const generateReport = async ({
  reportType,
  format,
  departmentIds,
  emails,
}) => {
  return dponetAPI.post('/training_courses/report', {
    report: {
      report_type: reportType,
      format,
      department_ids: departmentIds,
      emails,
    },
  })
}

const lessonContent = async ({ lessonContentId }) => {
  return dponetAPI.get(`/training_courses/lesson_content/${lessonContentId}`)
}

const exercisePreview = async ({ exerciseId }) => {
  return dponetAPI.get(`/training_courses/exercise/${exerciseId}`)
}

const trainingCourse = {
  index,
  show,
  modules,
  certificateConfig,
  courseCompanyConfig,
  upsertCourseCompanyConfig,
  notificationEmails,
  createNotificationEmail,
  deleteNotificationEmail,
  categories,
  portalLink,
  departments,
  generateReport,
  lessonContent,
  exercisePreview,
}

export default trainingCourse
